export const FETCH_ALL_SIZE = 10000;
